
const body = document.querySelector('body');
const searchBtn = document.getElementById('header-search-btn');
const searchModal = document.querySelector('.ct-search-modal');
const closeBtn = searchModal.querySelector('.ct-modal-close-btn');
const input = searchModal.querySelector('.search-input');
const searchOverlay = searchModal.querySelector('.searched-overlay');
const searchOverlayLoader = searchModal.querySelectorAll('.search-overlay-loading');
const suggestedProductsSection = document.getElementById('search-item');
const searcheditems = document.querySelector('.searched-results');

searchBtn.addEventListener('click', () => {
  searchModal.classList.toggle('hidden');
  body.style.overflow = 'hidden';
});

closeBtn.addEventListener('click', () => {
  searchModal.classList.add('hidden');
  body.style.overflow = '';
});

input.addEventListener('input', () => {
  const query = input.value;
  if (!query) {
    searchOverlay.classList.add('hidden');
    suggestedProductsSection.classList.remove('hidden');
    searcheditems.classList.add('hidden');
  }
  else {
    search(query)
      .then(() => {
          suggestedProductsSection.classList.add('hidden');
          searchOverlay.classList.remove('hidden');
          searcheditems.classList.remove('hidden');
    });
  }
});

function search(query) {
    searchOverlay.classList.add('hidden');
    searchOverlayLoader.forEach((e) => e.classList.remove('hidden'));
    return fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`
    )
        .then(res => res.json())
        .then(data => {
            const products = data.resources.results.products || [];
            const collections = data.resources.results.collections || [];
            updateSearchOverlay(products, collections);
        })
        .catch(err => console.error('Error fetching suggestions:', err))
        .finally(() => {
            searchOverlayLoader.forEach((e) => e.classList.add('hidden'));
        });
}


function updateSearchOverlay(products, collections) {
    // popularSearches(products);
    // searchedProducts(products);
    renderOverlay(products);
    searchSection(products, collections)
}


// function popularSearches(products) {
//   const popularSearch = searchOverlay.querySelector('.searched-results-popular-list');
//   popularSearch.innerHTML= '';
//   const ul = document.createElement('ul');
//   ul.className = 'popular-search-list';
//   ul.innerHTML = `
//       ${products
//         .slice(0,4).map(product => `<li class="popular-search-item"><a href="${product.url}">${product.title}</a></li>`)
//         .join('')}
//   `;
//   popularSearch.appendChild(ul);
// }

// function searchedProducts(products){
//   const productSection = searchOverlay.querySelector('.searched-results-products-list');
//   productSection.innerHTML = '';
//  const ul = document.createElement('ul');
//   ul.className = 'products-list';
//   ul.innerHTML = `
//       ${products
//         .slice(0,7).map(product => `<li>
//                       <a href="${product.url }">
//                         <div class="searched-product-image">
//                             <img
//                               src="${product.image}"
//                               width="50"
//                               height="70"
//                             >
//                         </div>
//                         <div class="searched-product-info">
//                           <div class="product-title">${ product.title }</div>
//                           <div class="product-price">${ formatMoney(product.price)}</div>
//                         </div>
//                       </a>
//                     </li>`)
//         .join('')}
//   `;
//   productSection.appendChild(ul);
// }


function formatMoney(cents) {
    return '$' + cents;
}



function searchSection(products, collections) {
    searcheditems.innerHTML = ``;
    if (products.length >= 1) {
        searcheditems.innerHTML = `
    <div class="search-items">
        <div class="suggestion-column">
          <div class="column-header">Popular searches</div>
          <div class="suggestion-list search-list">
            <ul>
              ${products
                .slice(0, 8)
                .map(product => `<li><a href="${product.url}">${product.title}</a></li>`)
                .join('')}
            </ul>
          </div>
        </div>
        <div class="suggestion-column">
          <div class="column-header">Collections</div>
          <div class="suggestion-list collection-list">
            <ul>
              ${collections
                .slice(0, 8)
                .map(collection => `<li><a href="${collection.url}">${collection.title}</a></li>`)
                .join('')}
            </ul>
          </div>
        </div>
        <div class="suggestion-column">
          <div class="column-header">Products</div>
          <div class="suggested-products">
            <ul>
              ${products
                .slice(0, 8)
                .map(product => `
                  <li class="suggested-product">
                    <a href="${product.url}">
                      <div class="ct-product-image">
                          <img
                            src="${product.image}"
                            width="200"
                            height="230"
                            class=""
                          >
                      </div>
                      <div class="ct-product-info">
                        <div class="ct-product-title">${product.title}</div>
                        <div class="ct-product-price">
                          ${formatMoney(product.price)}USD
                        </div>
                      </div>
                    </a>
                  </li>
                  `)
                .join('')}
            </ul>
          </div>
           <div class="show-all-results"><a href="https://oneshopgoes.myshopify.com/search?q=${encodeURIComponent(input.value)}">SHOW ALL RESULTS</a></div>
        </div>
      </div>
    `
    } else {
        searcheditems.innerHTML = `
     <div class='empty-results'>Sorry, nothing found for <b>${input.value}</b></div>
     <div class="best_sellers_p">   
     <a class="best_sellers_" href="https://oneshopgoes.myshopify.com/collections/best-selling-products" title=" Bestsellers">Try some of our bestsellers </a>
     </div>
    `
    }
}


function renderOverlay(products) {
    const overlay = document.querySelector('.ct-searched-results');
    overlay.innerHTML = '';
    if (products.length >= 1) {
        const div = document.createElement('div');
        div.className = 'popular-searches';
        div.id = 'popular-searches';
        div.innerHTML = `
      <div class="popular-searches-header"><h3>Popular Searches</h3></div>
      <div class="searched-results-popular-list">
        <ul class="popular-search-list">
          ${products
                .slice(0, 4)
                .map(product => `<li class="popular-search-item"><a href="${product.url}">${product.title}</a></li>`)
                .join('')}
        </ul>
      </div>
    `;
        const productDiv = document.createElement('div');
        productDiv.className = 'searched-products';
        productDiv.innerHTML = `
      <div class="popular-searches-header">
        <h3>Products</h3>
      </div>
      <div class="searched-results-products-list">
        <ul class="products-list">
          ${products
                .slice(0, 7)
                .map(product => `<li>
                        <a href="${product.url}">
                          <div class="searched-product-image">
                              <img
                                src="${product.image}"
                                width="50"
                                height="70"
                              >
                          </div>
                          <div class="searched-product-info">
                            <div class="product-title">${product.title}</div>
                            <div class="product-price">${formatMoney(product.price)}</div>
                          </div>
                        </a>
                      </li>`)
                .join('')}
        </ul>
      </div>
    `;
        overlay.appendChild(div);
        overlay.appendChild(productDiv);
    } else {
        overlay.innerHTML = `
     <div class='empty-results'>Sorry, nothing found for <b>${input.value}</b></div>
     <div class="best_sellers_p">   
     <a class="best_sellers_" href="https://oneshopgoes.myshopify.com/collections/best-selling-products" title=" Bestsellers">Try some of our bestsellers </a>
     </div>
    `;
    }

}

